import React from 'react'
import Popup from '../component/Popup'
const BASE = "https://source.unsplash.com/"
const WIDTH = window.innerWidth; //1396;
const HEIGHT = window.innerHeight; //785;
const FULL = BASE + WIDTH + "x" + HEIGHT + "/?";

export default class BgImage extends React.Component {
    constructor(props){
        super(props)
        // let FullPath = BASE + WIDTH + "X" + HEIGHT
        this.state = {
          img: false,
          isloading: true,
          imgSrc: FULL,
          showPopup: false,
          currentTheme:""
        }
      }

      componentDidMount(){
        fetch(FULL).then((x)=>{
          this.setState({isloading: false, imgSrc: x.url})
        })
        document.addEventListener('keydown',this.keydownHandler);
      }
    
      componentWillUnmount(){
        document.removeEventListener('keydown',this.keydownHandler);
      }

      keydownHandler = (e)=>{
        switch(e.keyCode){
            case 78: //n
                // console.log("n")
                this.getimage()
                break
            default: 
            }
        }

        getimage = (theme="")=>{
            let fullsrc = ""
            if(theme)
              fullsrc = FULL + theme
            else
              fullsrc = FULL + this.state.currentTheme
            // console.log(fullsrc)
            this.setState({isloading: true})
            fetch(fullsrc).then((x)=>{
              this.setState({isloading: !this.state.isloading, imgSrc: x.url})
            })
          }
        
        handlenrefrash = ()=>{
          this.getimage("")
        }

        handleSettingsClick = () =>{
          this.setState({showPopup: !this.state.showPopup})
        }
        handlenNewImageClick = (theme) =>{
          // console.log("image click")
          this.setState({currentTheme: theme,  showPopup: false})
          this.getimage(theme)
        }

    render(){
        const style ={
            position: "absolute",
            top: "80%",
            right: 0,
            zIndex: 1,
            marginRight: "10px"
        }
        const themes = ["Black", "White", "Wallpapers", "Nature", "Architecture", "Animals"]
        const {imgSrc, isloading, showPopup} = this.state
        return(
          <>
          <h1 id="title">Pomodoro Study Timer</h1>
            {
              isloading ? <div className="lds-dual-ring"></div> : <img alt="random" src={imgSrc}/>
            }
                <div style={style}>
                <button 
                    title="New Image"
                    alt="anti clockwise circle arrow" 
                    className="btnStyle passiveBtnColor" 
                    onClick={this.handlenrefrash}  
                    role="img">
                        &#8634;
                </button>
                <br/>
                <br/>
                <button 
                title="Image Theme"
                    alt="settings" 
                    className="btnStyle passiveBtnColor" 
                    onClick={this.handleSettingsClick}  
                    >
                      <span
                        role="img"
                        aria-label="setting">
                        ⚙️
                      </span>
                </button>
                </div>

                {
                  showPopup ?
                  <Popup>
                    <button onClick={this.handleSettingsClick} className="close">&times;</button>
                    <h1>Settings</h1>
                    <h3>Set image theme</h3>
                    {
                      themes.map((item, key)=>{
                        let active= ""
                        if(item === this.state.currentTheme)
                          active = "active"

                        return(<div key={key}  className={"pill "+active} value={item} onClick={()=>this.handlenNewImageClick(item)}>{item}</div >)
                      })
                    }
                    {/* <br/> */}
                    {/* <div className="pill active"  onClick={()=>{this.setState({currentTheme: ""})}}>Clear Theme</div> */}
                    <p>
                      Images are being provided by the <a target="_blank" rel="noopener noreferrer" href="https://unsplash.com/">Unsplash </a>   
                      I do not own any of the images.
                    </p>
                    {/* <input onKeyUp={(e)=> console.log(e.target.value)} placeholder="Custom theme" />
                    <button className="btnStyle passiveBtnColor">Search</button> */}
                  </Popup>
                  : ""
                }
            </>
        )
    }
}
